<template>
  <div>
    <div class="activity-status-container d-flex justify-content-between align-items-center position-relative">
      <div class="activity-status__details">
        <table class="status-table">
          <thead>
            <tr class="activity-status-border">
              <th class="md-2">
                <div class="activity-status__language">
                  <b-form-select v-model="selectedLanguageCulture" size="sm" class="language-dropdown" @change="onSelectedLanguageCultureChange">
                    <option v-for="language in languages" :key="language.language_id" :value="language.language_culture">{{ language.languageName }}</option>
                  </b-form-select>
                </div>
              </th>
              <th class="approval-status-title">Approval Status</th>
              <th class="approval-status-title">Verification Status</th>
              <th class="approval-status-title">Signed Off Status</th>
              <th class="approval-status-title">Review Status</th>
              <th class="approval-status-title span-48">Locked Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="pt-15 pb-15 md-2"></td>
              <td class="pt-15 pb-15">
                <span v-if="canAccess && !isLocked" class="approval-text" @click="openApprovalModal()">{{ approvalStatus | CapitalizeFirstLetters }}</span>
                <span v-else class="approval-status-text">{{ approvalStatus | CapitalizeFirstLetters }}</span>
              </td>
              <td class="pt-15 pb-15">
                <span v-if="(userRoles.canCraAccess || userRoles.canCraUBAccess) && !isLocked" class="approval-text" @click="openVerificationModal()">{{ verificationStatus | CapitalizeFirstLetters }}</span>
                <span v-else class="verification-status-text">{{ verificationStatus | CapitalizeFirstLetters }}</span>
              </td>
              <td class="pt-15 pb-15">
                <span v-if="userRoles.canPiAccess && isVerified && isApproved && !isLocked" class="approval-text" @click="openSignOffModal()">{{ signOffStatus | CapitalizeFirstLetters }}</span>
                <span v-else class="approval-status-text">{{ signOffStatus | CapitalizeFirstLetters }}</span>
              </td>
              <td class="pt-15 pb-15">
                <span v-if="(userRoles.canCraAccess || userRoles.canDmAccess || userRoles.canCraUBAccess) && !isLocked" class="approval-text" @click="openReviewModal()">{{ reviewStatus | CapitalizeFirstLetters }}</span>
                <span v-else class="verification-status-text">{{ reviewStatus | CapitalizeFirstLetters }}</span>
              </td>
              <td class="pt-15 pb-15 span-48">
                <span v-if="userRoles.canCraAccess || userRoles.canDmAccess || userRoles.canCraUBAccess" class="approval-text"  :class="{ disabled: disableActvityLockUnlockBtn }" @click="openLockModal()">{{ lockedStatus | CapitalizeFirstLetters }}</span>
                <span v-else class="verification-status-text">{{ lockedStatus | CapitalizeFirstLetters }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <user-confirmation-modal ref="userConfirmationModal" />
      <user-verification-modal ref="userVerificationModal" :userDetails="userDetails" />
    </div>

    <!-- Buttons -->
    <div class="activity-status__btns-container justify-content-center d-flex align-items-center position-relative p-15">
      <button class="activity-status__btns-container__telehealth-btn" v-if="canInitiateTelehealthCall() && !user.readOnly" @click="InitateVideoCall" :disabled="disableCallBtn()">
        <img src="static/img/telehealth-start.png" />&nbsp;
        <span class="activity-status__btns-container__telehealth-btn-text ml-3">Start Telehealth</span>
      </button>
    </div>
  </div>
</template>

<script>
import UserConfirmationModal from "@/components/modals/user-confirmation-modal";
import UserVerificationModal from "@/components/modals/user-verification-modal";
import localStorageService from "../../../services/localStorage";

import { mapGetters } from "vuex";
import _ from "lodash";
import jwtDecode from "jwt-decode";

export default {
  name: "participant-activity-response-activity-details",
  components: {
    UserConfirmationModal,
    UserVerificationModal
  },

  data() {
    return {
      VERIFIED: "verified",
      UNVERIFIED: "unverified",
      APPROVED: "approved",
      UNAPPROVED: "unapproved",
      SIGNEDOFF: "Signed off",
      UNSIGNEDOFF: "unsigned off",
      REVIEWED: "REVIEWED",
      UNREVIEWED: "UNREVIEWED",
      LOCKED: "LOCKED",
      UNLOCKED: "UNLOCKED",
      studyData: {},
      toggleFeatures: [],
      isTelehealthV2Enabled: false,
      teleHealthConfigured: false,
      visitDetails: {
        visitId: ""
      },
      studyId: this.$route.params.studyId,
      isCallBtnDisabled: false,
      legacyVal: true,
      signoffStatusText: {
        SIGNEDOFF: "Signed off",
        PENDING: "Unsigned off"
      },
      userDetails: {},
      disableActvityLockUnlockBtn : false
    };
  },

  watch: {
    getVideoCallStatus(isCallInProgress) {
      this.isCallBtnDisabled = isCallInProgress;
    }
  },
  computed: {
    ...mapGetters(["user", "getVideoCallStatus"]),
    verificationStatus() {
      if (this.surveyResponseStatus && this.surveyResponseStatus.verification_status) {
        return this.surveyResponseStatus.verification_status;
      }
      return this.UNVERIFIED;
    },

    approvalStatus() {
      if (this.surveyResponseStatus && this.surveyResponseStatus.approval_status) {
        return this.surveyResponseStatus.approval_status;
      }
      return this.UNAPPROVED;
    },
    signOffStatus() {
      if (this.surveyResponseStatus && this.surveyResponseStatus.signoff_status) {
        return this.signoffStatusText[this.surveyResponseStatus.signoff_status];
      }
      return this.UNSIGNEDOFF;
    },
    reviewStatus() {
      if (this.surveyResponseStatus && this.surveyResponseStatus.review_status) {
        return this.surveyResponseStatus.review_status;
      }
      return this.UNREVIEWED;
    },
    lockedStatus() {
      if (this.surveyResponseStatus && this.surveyResponseStatus.lock_status) {
        return this.surveyResponseStatus.lock_status;
      }
      return this.UNLOCKED;
    },
    canAccess() {
      if ((this.userRoles.canPiAccess || this.userRoles.canSubPiAccess || this.userRoles.canStudyCoordinatorAccess || this.userRoles.canHomeHealthAccess || this.userRoles.canCallCenterAccess) && !this.user.readOnly) {
        return true;
      }
      return false;
    },
    isApproved() {
      if (this.approvalStatus === this.APPROVED) {
        return true;
      }
      return false;
    },
    isVerified() {
      if (this.verificationStatus === this.VERIFIED) {
        return true;
      }
      return false;
    },
    isSignedOff() {
      if (this.signOffStatus === this.SIGNEDOFF) {
        return true;
      }
      return false;
    },
    isReviewed() {
      if (this.reviewStatus === this.REVIEWED) {
        return true;
      }
      return false;
    },
    isLocked() {
      if (this.lockedStatus === this.LOCKED) {
        return true;
      }
      return false;
    }
  },
  props: ["surveyId", "revisionId", "surveyResponseStatus", "userRoles", "languages", "activityLanguageCulture", "selectedLanguageCulture", "participantDetails", "participantId", "activity"],
  methods: {
    getLanguageNames() {
      if (this.languages) {
        return this.languages.map(langauge => langauge.name);
      }
    },

    onSelectedLanguageCultureChange(languageCulture) {
      this.$emit("onSelectedLanguageCultureChange", languageCulture);
    },

    openVerificationModal() {
      let title, yesBtnText, noBtnText;
      const statusParam = this.isVerified ? "unverify" : "verify";
      const requestBody = { verifiedBy: this.getUserName() };
      if (!this.isVerified) {
        title = "Have you thoroughly verified this activity?";
        yesBtnText = 'Yes, change to "verified" status';
        noBtnText = 'No, do not change to "verified" status';
        this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
          this.$api
            .studyResponseVerify(this.surveyId, this.revisionId, statusParam, this.participantId, requestBody)
            .then(() => {
              this.$emit("onChangeStatus");
              this.$toastr.success("Verification confirmed.");
            })
            .catch(() => {
              this.$toastr.error("Error");
            });
        });
      } else {
        title = "Are you sure you want to rescind verification for this activity?";
        yesBtnText = 'Yes, change to "unverified" status';
        noBtnText = 'No, do not change to "unverified" status';
        this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
          this.$api
            .studyResponseVerify(this.surveyId, this.revisionId, statusParam, this.participantId, requestBody)
            .then(() => {
              this.$emit("onChangeStatus");
              this.$toastr.success("Unverification confirmed.");
            })
            .catch(() => {
              this.$toastr.error("Error");
            });
        });
      }
    },

    openApprovalModal() {
      let title, desc, submitBtnText, cancelBtnText, yesBtnText, noBtnText;
      const requestBody = { approvedBy: this.getUserName() };
      if (!this.isApproved) {
        title = `Approve ${this.activity.name}`;
        desc = `Herewith I confirm the completeness and correctness of the data by applying an electronic signature, using my account name and password. This electronic signature is the legally binding equivalent of my handwritten signature. I understand that this electronic signature is assigned only to my account name and password; no other person is authorized to use these.<br /><br />Please enter your username and password to approve.`;
        submitBtnText = "Yes, approve";
        cancelBtnText = "No, do not approve";
        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() =>
          this.$api
            .studyResponseApprove(this.surveyId, this.revisionId, this.participantId, requestBody)
            .then(() => {
              this.$emit("onChangeStatus");
              this.$toastr.success("Approval confirmed.");
            })
            .catch(() => {
              this.$toastr.error("Error");
            })
        );
      } else {
        title = "Are you sure you want to rescind approval for this activity?";
        yesBtnText = "Yes, unapprove";
        noBtnText = "No, do not unapprove";
        this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
          this.$api
            .studyResponseUnapprove(this.surveyId, this.revisionId, this.participantId, requestBody)
            .then(() => {
              this.$emit("onChangeStatus");
              this.$toastr.success("Unapproval confirmed.");
            })
            .catch(() => {
              this.$toastr.error("Error");
            });
        });
      }
    },
    openLockModal() {
      if (this.disableActvityLockUnlockBtn) {
        return
      }
      let title, yesBtnText, noBtnText;
      const requestBody = { lockedBy: this.getUserName() };
      if (!this.isLocked) {
        title = "Do you wish to lock this activity?";
        yesBtnText = 'Yes, change to "locked" status';
        noBtnText = 'No, do not change to "locked" status';
        this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
          this.$api
            .studyResponseLock(this.surveyId, this.revisionId, this.participantId, requestBody)
            .then(() => {
              this.$emit("onChangeStatus");
              this.$toastr.success("Locked confirmed.");
            })
            .catch(() => {
              this.$toastr.error("Error");
            });
        });
      } else {
        title = "Are you sure you want to unlock this activity?";
        yesBtnText = 'Yes, change to "unlocked" status';
        noBtnText = 'No, do not change to "unlocked" status';
        this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
          this.$api
            .studyResponseUnlock(this.surveyId, this.revisionId, this.participantId, requestBody)
            .then(() => {
              this.$emit("onChangeStatus");
              this.$toastr.success("Unlocked confirmed.");
            })
            .catch(() => {
              this.$toastr.error("Error");
            });
        });
      }
    },
    disableActvityLockUnlockStatus(){
      let dataString = localStorage.getItem('thread-userObj');
      let userDetails = JSON.parse(dataString);
      if(userDetails.restrictions && (userDetails.restrictions.includes('activity_response.lock') || userDetails.restrictions.includes('activity_response.unlock'))){
        this.disableActvityLockUnlockBtn = true;
      }
      else{
        this.disableActvityLockUnlockBtn = false;
      }
    },
    openReviewModal() {
      let title, desc, submitBtnText, cancelBtnText, yesBtnText, noBtnText;
      const requestBody = { reviewedBy: this.getUserName() };
      if (!this.isReviewed) {
        title = `Review ${this.activity.name}`;
        desc = `I hereby confirm the completeness and correctness of all data entered within this document by applying an electronic signature, using my account username and password. This electronic signature is the legally binding equivalent of my handwritten signature. I understand that this electronic signature is assigned only to my account username and password;  no other person is authorized to use my account information.<br /><br />Please enter your username and password to sign this document.`;
        submitBtnText = "Yes, review";
        cancelBtnText = "No, do not review";
        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.$api
            .studyResponseReview(this.surveyId, this.revisionId, this.participantId, requestBody)
            .then(() => {
              this.$emit("onChangeStatus");
              this.$toastr.success("Reviewed confirmed.");
            })
            .catch(() => {
              this.$toastr.error("Error");
            });
        });
      } else {
        title = "Are you sure you want to rescind the review for this activity?";
        yesBtnText = 'Yes, change to "Unreviewed" status';
        noBtnText = 'No, do not change to "Unreviewed" status';
        this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
          this.$api
            .studyResponseUnreview(this.surveyId, this.revisionId, this.participantId, requestBody)
            .then(() => {
              this.$emit("onChangeStatus");
              this.$toastr.success("Unreviewed Confirmed.");
            })
            .catch(() => {
              this.$toastr.error("Error");
            });
        });
      }
    },
    openSignOffModal() {
      let title, desc, submitBtnText, cancelBtnText;
      const requestBody = { signoffBy: this.getUserName() };
      if (!this.isSignedOff) {
        title = `Signoff ${this.activity.name}`;
        desc = `Herewith I confirm the completeness and correctness of all data entered into the THREAD Platform by applying an electronic signature, using my account name and password. This electronic signature is the legally binding equivalent of my handwritten signature. I understand that this electronic signature is assigned only to my account name and password; no other person is authorized to use these.<br /><br />Please enter username and password to sign this document.`;
        submitBtnText = "Yes, Signed Off";
        cancelBtnText = "No, do not Signed Off";
        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.$api
            .studyResponseSignOff(this.surveyId, this.revisionId, this.participantId, requestBody)
            .then(() => {
              this.$emit("onChangeStatus");
              this.$toastr.success("Signed off confirmed.");
            })
            .catch(() => {
              this.$toastr.error("Error");
            });
        });
      } else {
        title = `Unsigned Off ${this.activity.name}`;
        desc = `Herewith I confirm the completeness and correctness of all data entered into the THREAD Platform by applying an electronic signature,
        using my account name and password. This electronic signature is the legally binding equivalent of my handwritten signature.
        I understand that this electronic signature is assigned only to my account name and password; no other person is authorized to use these.
        <br /><br />Please enter username and password to sign this document.`;
        submitBtnText = "Yes, Unsigned Off";
        cancelBtnText = "No, do not Unsigned Off";
        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.$api
            .studyResponseUnsignOff(this.surveyId, this.revisionId, this.participantId, requestBody)
            .then(() => {
              this.$emit("onChangeStatus");
              this.$toastr.success("Unsigned Off confirmed.");
            })
            .catch(() => {
              this.$toastr.error("Error");
            });
        });
      }
    },

    // TELEHEALTH

    canInitiateTelehealthCall() {
      //Call cannot be initiated for these statuses
      let statusArray = ["INVITED", "NOTINVITED", "REGISTERED", "DISQUALIFIED", "WITHDRAWSTUDY"];
      if (!this.legacyVal) {
        statusArray = ["INVITED", "NOTINVITED", "REGISTERED", "DISCONTINUED"];
      }
      if (statusArray.includes(this.participantDetails.status)) {
        return false;
      }

      if (this.user.userRole === "Interviewer") {
        return true;
      }
      if (
        this.studyData.telehealthIntegration &&
        this.isTelehealthV2Enabled &&
        (this.userRoles.canPiAccess || this.userRoles.canSubPiAccess || this.userRoles.canStudyCoordinatorAccess || this.userRoles.canHomeHealthAccess || this.userRoles.canCallCenterAccess) &&
        this.user.countries &&
        _.chain(this.user.countries)
          .filter({
            isTelehealthEnabled: true,
            country_id: this.participantDetails.countryId
          })
          .size()
          .value() > 0
      ) {
        return true;
      }

      return false;
    },

    getStudyDetails() {
      this.$api
        .getStudyDataFact(this.studyId)
        .then(
          response => {
            if (response.body) {
              this.studyData = response.body;
              if (!this.userRoles.canSysAdminAccess) {
                this.getToggledFeatures();
              }
              if (this.teleHealthConfigured && this.userRoles.canPiAccess) {
                this.getAppointmentDetails();
              }
            }
          },
          error => {
            const err = error.body && error.body.message ? error.body.message : "Error while getting the study details";
            this.$toastr.error(err);
          }
        )
        .catch(error => {
          if (error && (error.message || error.body.message)) {
            this.$toastr.error(error.message || error.body.message);
          } else {
            this.$toastr.error("Unable to fetch the study details");
          }
        });
    },

    getToggledFeatures() {
      this.$api.getToggleFeaturesFact(this.studyId).then(
        response => {
          if (response.body) {
            this.toggleFeatures = response.body.studyFeatures;
            this.toggleFeatures.forEach(feature => {
              if (feature.featureKey === "TELEHEALTH") {
                this.isTelehealthV2Enabled = feature.enabled;
              } else if (feature.featureKey === "EDC") {
                // this.edcEnabled = feature.enabled;
              }
            });
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting trueclinic features.");
        }
      );
    },

    getAppointmentDetails() {
      this.$api.getAppointmentDetailsFact(this.participantDetails.id).then(
        response => {
          this.visitDetails = response.body;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting encounter status.");
        }
      );
    },

    InitateVideoCall() {
      if (this.user.userRole === "Interviewer") {
        this.$root.$emit("initiate_th", 0);
      }
      this.isCallBtnDisabled = true;
      //Emit an event to show/start the video call component
      this.$root.$emit("videoCallStarted", {
        participantId: this.participantDetails.id,
        studyId: this.studyId,
        countryId: this.participantDetails.countryId,
        deviceRegistrationStatus: this.participantDetails.deviceRegistrationStatus
      });
    },

    disableCallBtn() {
      return !!(this.getVideoCallStatus || this.isCallBtnDisabled);
    },
    checkLegacyValue() {
      this.$api.getLegacyData(this.studyId).then(response => {
        if (response) {
          this.legacyVal = response.body;
        }
      });
    },
    getloggedInUserDetails() {
      // As sometimes few of the properties don't set in localstorage, then we use data from this fallback method.
      let userDetails = localStorageService.getItem("userObj");
      this.$api.getProfileDetails(userDetails.id, this.studyId).then(data => {
        this.userDetails = data && data.body;
      });
    },
    getUserDetails(userData) {
      if (this.user && this.user[userData]) {
        return this.user[userData];
      } else if (this.userDetails && this.userDetails[userData]) {
        return this.userDetails[userData];
      } else {
        const token = localStorageService.getItem("token");
        const tokenObj = jwtDecode(token);
        return tokenObj[userData]
      }
    },
    getUserName() {
      return this.getUserDetails("firstName") + " " + this.getUserDetails("lastName");
    }
  },

  mounted() {
    this.getloggedInUserDetails();
    this.getStudyDetails();
    this.checkLegacyValue();
    this.$root.$on("videoCallEnded", () => {
      this.isCallBtnDisabled = false;
    });
    this.$root.$on("videoCallCancelled", () => {
      this.isCallBtnDisabled = false;
    });
    this.disableActvityLockUnlockStatus();
  }
};
</script>

<style scoped lang="scss">
.language-dropdown {
  background: #5290e7 url(/static/img/arrow-down-blue.png) no-repeat;
  border: 0;
  width: auto;
  background-color: transparent !important;
  background-position-x: 96% !important;
}
.activity-status {
  &-container {
    position: relative;
    /* height: 88px; */
  }

  &__language {
    width: 100px;
  }

  &__btns-container {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    background: #f7f7f7;

    &__btn {
      cursor: pointer;
      width: 96px;
      height: 40px;
      border-radius: 4px;
      border: solid 1px #e4e8eb;
      background-color: #ffffff;

      &-text {
        width: 96px;
        height: 16px;
        /* font-family: Roboto; */
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #4c8ce4;
      }
    }

    &__line {
      width: 1px;
      background-color: #dedede;
      height: 40px;
    }

    &__telehealth-btn {
      cursor: pointer;
      width: 150px;
      height: 40px;
      border-radius: 4px;
      border: solid 1px #e4e8eb;
      background-color: #ffffff;

      &-text {
        width: 132.3px;
        height: 16px;
        /* font-family: Roboto; */
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #4c8ce4;
      }
    }
  }

  &__details {
    table {
      border-bottom: 2px solid #bfbfbf;
    }
    width: 100%;
    .activity-status-border {
      border: solid 1px #e4e8eb;
      background-color: #f9f9fb;
    }
    .verification-status-title,
    .approval-status-title {
      font-weight: bold;
      font-family: "Lato", sans-serif;
      font-size: 12px;
      text-align: left;
      color: #9b9b9b;
    }

    .verification-status-text,
    .approval-status-text {
      font-size: 14px;
      font-family: "RobotoRegular";
      color: #a4a4a4;
    }
    .approval-text {
      font-size: 14px;
      font-family: "RobotoRegular";
      color: #4c8ce4;
      cursor: pointer;
      &.disabled {
        color: #a4a4a4;
        cursor: no-drop;
      }
    }
  }
}
table {
  width: 100%;

  &.status-table {
    display: flex;
    flex-direction: column;
  }

  tr {
    display: flex;
    flex: 1;
    align-items: center;

    td,
    th {
      flex: 6;

      &.md-2 {
        flex: 12;
      }
      &.span-48 {
        flex: 12 48px;
      }

      @media (max-width: 768px) {
        &.md-2 {
          flex: 6;
        }
        &.span-48 {
          flex: 6;
        }
      }
    }
  }
}
table thead {
  background: #f9f9fb;
}
table thead th {
  vertical-align: middle;
}
table td {
  text-align: left;
}
@media screen and (max-width: 768px) {
  .activity-status {
    &__language {
      width: auto;
    }
  }
}
</style>
